import { FC } from 'react';
import { FormControl, FormLabel, Input, SimpleGrid } from '@chakra-ui/react';

type Props = {
  token: string;
};

/**
 * 編集モーダル用の Zeus Token フォーム(readonly)です。
 */
export const ZeusTokenForm: FC<Props> = ({ token }) => (
  <FormControl>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>Zeus トークン</FormLabel>
      <Input value={token} disabled />
    </SimpleGrid>
  </FormControl>
);
